import RolePanelShell from "@/components/feature/panel/RolePanelShell";
import { veliConfig } from "@/data/panels";

export default function VeliLayout() {
  return <RolePanelShell {...veliConfig} />;
}